var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ratings" },
    [
      _vm._l(_vm.fullstars, function(n, index) {
        return _c("i", { staticClass: "fa fa-star" })
      }),
      _vm._v(" "),
      _vm._l(_vm.emptystars, function(n, index) {
        return _c("i", { staticClass: "fa fa-star-o" })
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }